import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
    ViewChild,
} from "@angular/core";
import { TreeNode, MessageService } from "primeng/api";
import { TreeTable } from "primeng/treetable";
import { TreeAccountsComponent } from "./tree-accounts.component";
import { Totaling } from "../domain/totaling";
import { AccountService } from "../service/account.service";
import * as _ from "lodash";
import { LookupService } from "../service/lookup.service";
import { ReportDefinitionEditComponent } from "./reportdefinition-edit.component";

@Component({
    selector: "dimension-totaling",
    templateUrl: "./dimension-totaling.component.html",
})
export class DimensionTotalingComponent implements OnInit {
    constructor(
        private accountService: AccountService,
        private lookupService: LookupService
    ) { }

    @ViewChild("accountsIncludedTree", { static: false })
    accountsIncludedTree: TreeAccountsComponent;
    @ViewChild("accountsLineTree", { static: false })
    accountsLineTree: TreeAccountsComponent;
    @ViewChild("accountsExcludedTree", { static: false })
    accountsExcludedTree: TreeAccountsComponent;
    @ViewChild("accountsAllTree", { static: false })
    accountsAllTree: TreeAccountsComponent;
    @ViewChild("accountsTotalingTree", { static: false })
    accountsTotalingTree: TreeTable;
    @ViewChild("accountsExcludedTreeRangeLeft", { static: false })
    accountsExcludedTreeRangeLeft: TreeAccountsComponent;
    @ViewChild("accountsExcludedTreeRangeRight", { static: false })
    accountsExcludedTreeRangeRight: TreeAccountsComponent;

    @Input() mode: string = "accounts";
    @Input() reportId: string;
    @Input() lineId: string;
    @Input() isDisabled: boolean;

    @Input() dimensionId: number;

    @Input() totaling: Totaling[] = [];

    @Output() totalingChange = new EventEmitter<Totaling[]>();

    @Input() messageService: MessageService;

    @Output() voted = new EventEmitter<boolean>();

    //@Output() change: EventEmitter<Ids[]> = new EventEmitter<Ids[]>();

    items: any[];

    displayModalForSingles: boolean = false;
    displayModalForRanges: boolean = false;

    index = 0;

    tableColumns: any[] = [{ field: "name", header: "Name", width: "100%" }];

    selectedSingleAccountsLeft: TreeNode[] = [];
    selectedSingleAccountsRight: TreeNode[] = [];
    selectedSingleAccountFrom: TreeNode = null;
    selectedSingleAccountTo: TreeNode = null;
    selectedAccounts: TreeNode[] = [];
    accountsForTableExist: boolean;
    loading: boolean = false;
    accountsForTable: TreeNode[] = [];
    accountsForTableForAccountTo: TreeNode[] = [];
    excludedLineAccounts: TreeNode[] = [];
    filteredExcludedLineAccounts: TreeNode[] = [];
    rangesModalStep: number = 1;
    isChip: boolean;

    selectedChip: Totaling = null;
    totalingTemp: Totaling[] = [];
    selectedChipTemp: Totaling = null;
    get pickButtonDisabled() {
        return !(
            this.selectedSingleAccountsLeft &&
            this.selectedSingleAccountsLeft.length > 0
        );
    }

    get unpickButtonDisabled() {
        return !(
            this.selectedSingleAccountsRight &&
            this.selectedSingleAccountsRight.length > 0
        );
    }

    get rangesModalTitle() {
        let text = "Select Accounts: From ";

        text += this.selectedSingleAccountFrom
            ? this.selectedSingleAccountFrom.data.code
            : "___";
        text += " to ";
        text += this.selectedSingleAccountTo
            ? this.selectedSingleAccountTo.data.code
            : "___";

        return text;
    }

    ngOnInit() { }

    resetSelections() {
        this.selectedAccounts = [];
        this.selectedSingleAccountsLeft = [];
        this.selectedSingleAccountsRight = [];
        this.selectedSingleAccountsLeft = null;
        this.selectedSingleAccountsRight = null;
        this.selectedSingleAccountFrom = null;
        this.selectedSingleAccountTo = null;
        this.rangesModalStep = 1;
        //this.getAccountsForTable();//zakomentirano jeli potrebno refresati i raditi poziv kada se zatvara kompomenta
    }

    closeModal() {
        this.resetSelections();
        this.displayModalForSingles = false;
        this.displayModalForRanges = false;
        this.isChip = false;
        this.selectedChip = null;
    }

    openModalForSingles() {
        this.selectedSingleAccountsLeft = null;
        this.resetSelections();
        this.getAccountsForTable();
        this.displayModalForSingles = true;
        this.displayModalForRanges = false;
    }

    openModalForRanges() {
        this.resetSelections();
        this.getAccountsForTable();
        this.displayModalForSingles = false;
        this.displayModalForRanges = true;
        this.rangesModalStep = 1;
    }

    changeTotaling(newValue: Totaling[]) {
        this.totaling = newValue;
        this.totalingChange.emit(newValue);
        if (!this.isChip) {
            this.selectedChip = null;
        }
        // this.selectedChip = null;
        //this.closeModal();
    }

    getAccountsForTable(
        accountsToRemove: TreeNode[] = [],
        selectedRangeAccountFrom: TreeNode = null,
        loadAllAccounts: boolean = false
    ) {
        this.loading = true;

        if (this.mode == "accounts") {
            if (loadAllAccounts) {
                this.accountService
                    .getAll(this.reportId, [])
                    .then((accounts) =>
                        this.loadAccounts(
                            accounts,
                            accountsToRemove,
                            selectedRangeAccountFrom
                        )
                    );
            }
            else {
                this.accountService
                    .getExcludedForLine(this.lineId)
                    .then((accounts) =>
                        this.loadAccounts(
                            accounts,
                            accountsToRemove,
                            selectedRangeAccountFrom
                        )
                    );
            }
        } else {
            console.log("loadanje accounta - else accounts")
            this.lookupService
                .getDimensionValues(this.dimensionId)
                .then((accounts) =>
                    this.loadAccounts(
                        accounts,
                        accountsToRemove,
                        selectedRangeAccountFrom
                    )
                );
        }
    }

    loadAccounts(
        accounts: TreeNode[],
        accountsToRemove: TreeNode[] = [],
        selectedRangeAccountFrom: TreeNode = null
    ) {
        console.log("accounts", accounts.length)
        console.log(accounts)
        this.accountsForTable = accounts;
        this.accountsForTableExist =
            this.accountsForTable && this.accountsForTable.length > 0
                ? true
                : false;
        this.loading = false;

        this.accountsForTable = this.deleteTreeNodesFromTreeNodes(
            accountsToRemove,
            this.accountsForTable
        );

        if (selectedRangeAccountFrom) {
            this.selectedSingleAccountFrom = selectedRangeAccountFrom;
        }
    }

    saveSinglesAccountTotaling() {

        if (this.selectedAccounts.length > 0) {
            let chip = new Totaling();
            chip.Type = 3;
            chip.Ids = this.selectedAccounts.map((a) => a.data.id).join("|");
            chip.Names = this.selectedAccounts.map((a) => a.data.code).join("|");
            console.log("totalingSaveAccount---------")
            console.log(this.totaling)
            if (this.selectedAccounts.length > 10) {
                chip.Descriptions =
                    "<p>" +
                    this.selectedAccounts
                        .slice(0, 10)
                        .map((a) => a.data.name)
                        .join("<br/>") +
                    "</p>" +
                    "<p>...</p>";
            } else {
                chip.Descriptions =
                    "<p>" +
                    this.selectedAccounts.map((a) => a.data.name).join("<br/>") +
                    "</p>";
            }

            this.addOrChangeTotalingChip(chip);
        }
        /*else{
            this.totaling = this.totaling.filter((chip) => {
                return chip.Ids !== '';
            });
           //this.totaling.splice(0, this.totaling.length);
            console.log("saveSinglesAccountTotaling-this.totaling");
            console.log(this.totaling);
            //this.totaling = null;
            this.changeTotaling(this.totaling);
        }
        */

    }

    selectSingleAccountFrom() {
        if (this.selectedSingleAccountFrom) {
            this.accountsForTableForAccountTo = [];

            let allSiblings = this.selectedSingleAccountFrom.parent
                ? _.cloneDeep(this.selectedSingleAccountFrom.parent.children)
                : _.cloneDeep(this.accountsForTable);

            allSiblings.forEach((node) => {
                node.children = null;
                node.expanded = false;
                node.leaf = true;
            });

            this.accountsForTableForAccountTo = allSiblings.filter(
                (n) =>
                    parseInt(n.data.code) >
                    parseInt(this.selectedSingleAccountFrom.data.code)
            );
            this.rangesModalStep = 2;
        }
    }

    saveRangeAccountTotaling() {
        if (
            parseInt(this.selectedSingleAccountFrom.data.code) >=
            parseInt(this.selectedSingleAccountTo.data.code)
        ) {
            this.messageService.add({
                severity: "error",
                summary: "Range saving failed",
                detail: "First account must have a lower code than the second one",
            });
        } else {
            let chip = new Totaling();
            chip.Type = 2;
            chip.Ids =
                this.selectedSingleAccountFrom.data.id +
                ".." +
                this.selectedSingleAccountTo.data.id;
            chip.Names =
                this.selectedSingleAccountFrom.data.code +
                ".." +
                this.selectedSingleAccountTo.data.code;
            chip.Descriptions =
                this.selectedSingleAccountFrom.data.name +
                "<br/>...<br/>" +
                this.selectedSingleAccountTo.data.name;

            this.addOrChangeTotalingRangeChip(chip);
        }
    }

    addOrChangeTotalingChip(chip: Totaling) {
        //console.log("chipIndex",chip.TotalingIndex)
        console.log(" addOrChangeTotalingChip")
        console.log(this.totalingTemp)
        console.log(this.selectedChipTemp)
        if (this.selectedChip) {
            this.selectedChipTemp = this.selectedChip;
            let chipToChange = this.totalingTemp.find(
                (chip) => chip.Ids == this.selectedChipTemp.Ids
            );
            let chipToChangeIndex = this.totalingTemp.indexOf(chipToChange);
            this.totaling.splice(chipToChangeIndex, 1, chip);
        } else {
            this.totaling.push(chip); //TB
            console.log("this.totaling.length", this.totaling.length)
            chip.TotalingIndex = this.totaling.length - 1;   //TODO PROVJERITI!!!!!!!! zašto ne prije PUSHa
            this.selectedChip = chip;
            this.isChip = true;
        }
        this.changeTotaling(this.totaling);
    }

    addOrChangeTotalingRangeChip(chip: Totaling) {
        if (this.selectedChip) {
            this.selectedChipTemp = this.selectedChip;
            let chipToChange = this.totalingTemp.find(
                (chip) => chip.Ids == this.selectedChipTemp.Ids
            );
            let chipToChangeIndex = this.totalingTemp.indexOf(chipToChange);
            this.totaling.splice(chipToChangeIndex, 1, chip);
        } else {
            chip.TotalingIndex = this.totaling.length - 1;
            this.totaling.push(chip); //TB
            this.selectedChip = chip;
            this.isChip = true;
        }
        this.changeTotaling(this.totaling);
    }

    handleChange(e) {
        this.index = e.index;
    }

    onRemove() {
        this.changeTotaling(this.totaling);
    }

    openExistingChip(col) {
        console.log("openExist")
        this.selectedChip = col;
        this.isChip = true;
        this.copyArray(this.totaling);
        console.log("this.totaling")
        console.log(this.totaling)
        //const found = this.totaling.find((element) => element.Ids == this.selectedChip.Ids);
        const matchedItem = this.totaling.find(item => item.Ids === this.selectedChip.Ids);
        console.log(matchedItem);
        console.log(matchedItem.TotalingIndex);
        this.selectedChip.TotalingIndex = matchedItem.TotalingIndex;
        console.log("this.selectedChip-Open", this.selectedChip)
        console.log("this.selectedChip-INDEX", this.selectedChip.TotalingIndex)

        this.selectedChipTemp = this.selectedChip;
        console.log("this.selectedChipTemp")
        console.log(this.selectedChipTemp)
        if (this.selectedChip.Type == 3) {
            //is a single
            console.log("single")
            this.loading = true;
            this.displayModalForSingles = true;

            if (this.mode == "accounts") {
                console.log("accounts")
                this.accountService
                    .createTreeForList(this.selectedChip.Ids.trim())
                    .then((accounts) => {
                        accounts.forEach((node) => {
                            this.expandRecursive(node, false);
                        });
                        this.selectedAccounts = accounts;
                        this.getAccountsForTable(this.selectedAccounts);
                    });
            } else {
                console.log("this.model", this.mode)
                //TBRKIC izmjena na post
                this.lookupService
                    .createTreeForList(this.selectedChip.Ids.trim())
                    .then((accounts) => {
                        accounts.forEach((node) => {
                            this.expandRecursive(node, false);
                        });
                        this.selectedAccounts = accounts;
                        this.getAccountsForTable(this.selectedAccounts);
                    });
            }
        }

        if (this.selectedChip.Type == 2) {
            this.isChip = true;
            this.displayModalForRanges = true;
            let selectedAccountFromId = this.selectedChip.Ids.split("..")[0];
            let selectedAccountToId = this.selectedChip.Ids.split("..")[1];

            if (this.mode == "accounts") {
                this.accountService
                    .createTreeFor(
                        selectedAccountFromId + "|" + selectedAccountToId
                    )
                    .then((accounts) => {
                        let accountFrom = accounts.find(
                            (a) => a.data.id == selectedAccountFromId
                        );
                        let accountTo = accounts.find(
                            (a) => a.data.id == selectedAccountToId
                        );
                        this.selectedSingleAccountFrom = accountFrom;
                        this.selectedSingleAccountTo = accountTo;
                        this.getAccountsForTable(this.selectedAccounts);
                    });
            } else {
                this.lookupService
                    .createTreeFor(
                        selectedAccountFromId + "|" + selectedAccountToId
                    )
                    .then((accounts) => {
                        let accountFrom = accounts.find(
                            (a) => a.data.id == selectedAccountFromId
                        );
                        let accountTo = accounts.find(
                            (a) => a.data.id == selectedAccountToId
                        );
                        this.selectedSingleAccountFrom = accountFrom;
                        this.selectedSingleAccountTo = accountTo;
                        this.getAccountsForTable(this.selectedAccounts);
                    });
            }
        }
    }

    private expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (!node.leaf && node.children != null) {
            node.children.forEach((childNode) => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }

    pick() {
        this.selectedSingleAccountsLeft.forEach((node) => {
            this.selectedAccounts.push(node);
            this.selectedAccounts.forEach((n) => {
                this.expandRecursive(n, false);
            });
            this.selectedAccounts = [...this.selectedAccounts];
        });
        console.log("  this.accountsForTable", this.accountsForTable.length);

        this.accountsForTable = this.deleteTreeNodesFromTreeNodes(
            this.selectedSingleAccountsLeft,
            this.accountsForTable
        );

        this.saveSinglesAccountTotaling()
        console.log("this.selectedAccounts.length")
        console.log(this.selectedAccounts.length)
        console.log("this.selectedAccounts:")
        console.log(this.selectedAccounts)
        this.selectedSingleAccountsLeft = [];
        this.selectedSingleAccountsRight = [];



        setTimeout(() => {
            this.copyArray(this.totaling);
            console.log("totaling");
            console.log(this.totaling)
            console.log("this.selectedChip -before 1")
            console.log(this.selectedChip)

            let matchedItem = this.totaling.find(item => item.TotalingIndex === this.selectedChip.TotalingIndex);

            //console.log(matchedItem)

            if (matchedItem !== null && typeof (matchedItem) !== "undefined") {
                console.log("matchedItem !=null")
                console.log(matchedItem)
                this.selectedChip.TotalingIndex = matchedItem.TotalingIndex;



                this.selectedChip = this.totaling[this.selectedChip.TotalingIndex];
                console.log("this.selectedChip -after")
                console.log(this.selectedChip)
                console.log(this.selectedChip.Ids)

                if (this.mode == "accounts") {
                    console.log("accounts")
                    this.accountService
                        .createTreeForList(this.selectedChip.Ids.trim())
                        .then((accounts) => {
                            console.log("------")
                            console.log(this.selectedChip.Ids.trim())
                            console.log(accounts.length)
                            accounts.forEach((node) => {
                                this.expandRecursive(node, false);
                            });
                            this.selectedAccounts = accounts;
                            this.getAccountsForTable(this.selectedAccounts);
                        });

                } else {
                    console.log("dimensions")
                    this.lookupService
                        .createTreeForList(this.selectedChip.Ids.trim())
                        .then((accounts) => {
                            accounts.forEach((node) => {
                                this.expandRecursive(node, false);
                            });
                            this.selectedAccounts = accounts;
                            console.log()
                            this.getAccountsForTable(this.selectedAccounts);
                        });

                }


            } else {
                console.log("matchedItem ==null")
                console.log(matchedItem)
                this.resetSelections();
                this.getAccountsForTable();
            }


        }, 2700);




    }

    unpick() {
        let i;
        let flagToSave = 1;

        for (i = 0; i < this.selectedSingleAccountsRight.length; i++) {
            if (this.selectedSingleAccountsRight[i].parent != null) {
                flagToSave = 0;
                alert("Removing an intermediate node in the account class hierarchy is not allowed.")
                break;
            }
        }
        if ((flagToSave == 1)) {
            if (this.selectedAccounts.length > this.selectedSingleAccountsRight.length) {

                if (this.selectedSingleAccountsRight && (flagToSave == 1)) {
                    this.selectedAccounts = this.deleteTreeNodesFromTreeNodes(
                        this.selectedSingleAccountsRight,
                        this.selectedAccounts
                    );
                    this.getAccountsForTable(this.selectedAccounts, null, true);
                    this.saveSinglesAccountTotaling()
                    this.selectedSingleAccountsRight = [];
                    this.selectedSingleAccountsLeft = [];


                    setTimeout(() => {
                        this.copyArray(this.totaling);
                        console.log("totaling");
                        console.log(this.totaling)
                        console.log("this.selectedChip -before 1")
                        console.log(this.selectedChip)

                        let matchedItem = this.totaling.find(item => item.TotalingIndex === this.selectedChip.TotalingIndex);
                        console.log("matchedItem -before 1")
                        console.log(matchedItem)
                        this.selectedChip = matchedItem;
                        //this.selectedChip.TotalingIndex = matchedItem.TotalingIndex;



                        this.selectedChip = this.totaling[this.selectedChip.TotalingIndex];
                        console.log("this.selectedChip -after")
                        console.log(this.selectedChip)
                        console.log(this.selectedChip.Ids)

                        if (this.mode == "accounts") {
                            this.accountService
                                .createTreeFor(this.selectedChip.Ids.trim())
                                .then((accounts) => {
                                    console.log("------")
                                    console.log(this.selectedChip.Ids.trim())
                                    console.log(accounts.length)
                                    accounts.forEach((node) => {
                                        this.expandRecursive(node, false);
                                    });
                                    this.selectedAccounts = accounts;
                                    this.getAccountsForTable(this.selectedAccounts, null, true);
                                });

                        } else {
                            console.log("dimensions")
                            this.lookupService
                                .createTreeFor(this.selectedChip.Ids.trim())
                                .then((accounts) => {
                                    accounts.forEach((node) => {
                                        this.expandRecursive(node, false);
                                    });
                                    this.selectedAccounts = accounts;
                                    this.getAccountsForTable(this.selectedAccounts);
                                });

                        }
                    }, 2700);

                }
            } else {
                alert("At least one account must be selected.")
            }
        }
        if (this.selectedChip) {

        }


    }

    deleteNodeById(topNode: TreeNode, id: number) {
        if (topNode.children != null) {
            let i;
            for (i = 0; i < topNode.children.length; i++) {
                if (topNode.children[i].data.id === id) {
                    topNode.children.splice(i, 1);
                    return;
                } else {
                    this.deleteNodeById(topNode.children[i], id);
                }
            }
        } else {
            return;
        }
    }

    deleteTreeNodesFromTreeNodes(needles: TreeNode[], haystack: TreeNode[]) {
        needles.forEach((needle) => {
            haystack.forEach((parentNode) => {
                if (parentNode.data.id === needle.data.id) {
                    haystack.splice(
                        haystack.findIndex(
                            (value) => value.data.id === parentNode.data.id
                        ),
                        1
                    );
                } else {
                    this.deleteNodeById(parentNode, needle.data.id);
                }
            });
            haystack = [...haystack];
        });
        return haystack;
    }

    enterKeyPressedInLeftTable(filteredAccounts) {
        this.selectedSingleAccountsLeft = filteredAccounts;
        this.pick();
        this.getAccountsForTable(this.selectedAccounts);
    }
    removeAccounts(id) {
        this.totaling = this.totaling.filter((chip) => {
            return chip.Ids !== id;
        });
        this.changeTotaling(this.totaling);
    }
    copyArray(arr) {
        this.totalingTemp.length = 0;
        for (var i = 0; i < arr.length; i++) {
            let chip = new Totaling();
            chip.Type = arr[i].Type
            chip.Ids = arr[i].Ids
            chip.Names = arr[i].Names
            chip.Descriptions = arr[i].Descriptions
            chip.TotalingIndex = i
            arr[i].TotalingIndex = i;
            this.totalingTemp.push(chip);
        }
    }

}
